var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from 'styled-components';
import { useExternalWallets } from '../../providers/ExternalWalletContext.js';
import { StyledCpslTileButton } from '../common.js';
import { CpslButton, CpslIcon, CpslInput, CpslText } from '@usecapsule/react-components';
import { useModalStore } from '../../stores/index.js';
import { ModalStep } from '../../utils/steps.js';
import { useState } from 'react';
const HAS_MORE_LENGTH = 3;
export const ExternalWallets = () => {
    const { wallets, connectExternalWallet } = useExternalWallets();
    const setSelectedExternalWalletId = useModalStore(state => state.setSelectedExternalWalletId);
    const setStep = useModalStore(state => state.setStep);
    const showAll = useModalStore(state => state.step === ModalStep.EX_WALLET_MORE);
    const [search, setSearch] = useState('');
    const hasMore = wallets.length > HAS_MORE_LENGTH;
    const walletsToShow = showAll || !hasMore
        ? search
            ? wallets.filter(w => w.name.toLowerCase().includes(search.toLowerCase()))
            : wallets
        : wallets.slice(0, HAS_MORE_LENGTH);
    const showMoreButton = !showAll && hasMore;
    const handleShowAll = () => {
        setStep(ModalStep.EX_WALLET_MORE);
    };
    const handleCapsuleClick = () => {
        setStep(ModalStep.AUTH_MORE);
    };
    const handleWalletClick = (wallet) => () => {
        setSelectedExternalWalletId(wallet.id);
        setStep(ModalStep.EX_WALLET_SELECTED);
        if (wallet.installed) {
            connectExternalWallet(wallet);
        }
        else if (wallet.isMobile) {
            connectExternalWallet(wallet, true);
        }
    };
    return (_jsxs(Container, { "$maxHeight": showAll, children: [showAll && (_jsxs(_Fragment, { children: [_jsx(SearchInputWrapper, { children: _jsx(SearchInput, { placeholder: "Search for your wallet", onCpslInput: (e) => __awaiter(void 0, void 0, void 0, function* () {
                                setSearch(e.target.value);
                            }), value: search, style: { width: '100%' }, children: _jsx(SearchIcon, { slot: "start", icon: "search" }) }) }), _jsx(CpslButton, { fullWidth: true, variant: "tertiary", onClick: handleCapsuleClick, children: _jsxs(WalletButtonOuterContainer, { children: [_jsxs(WalletButtonInnerContainer, { children: [_jsx(CpslIcon, { slot: "start", icon: "capsule" }), _jsx(CpslText, { weight: "medium", children: "Capsule" })] }), _jsx(Badge, { "$show": true, "$variant": "installed", children: _jsx(CpslText, { variant: "body2XS", weight: "medium", children: "Available" }) })] }) })] })), walletsToShow.map(wallet => showAll ? (_jsx(CpslButton, { fullWidth: true, variant: "tertiary", onClick: handleWalletClick(wallet), children: _jsxs(WalletButtonOuterContainer, { children: [_jsxs(WalletButtonInnerContainer, { children: [_jsx(CpslIcon, { slot: "start", src: wallet.iconUrl }), _jsx(CpslText, { weight: "medium", children: wallet.name })] }), _jsx(Badge, { "$show": wallet.isMobile || wallet.installed, "$variant": wallet.installed ? 'installed' : 'mobile', children: _jsx(CpslText, { variant: "body2XS", weight: "medium", children: wallet.installed ? 'Installed' : 'Mobile' }) })] }) }, wallet.id)) : (_jsx(WalletTileButton, { src: wallet.iconUrl, onClick: handleWalletClick(wallet), children: _jsxs(TileButtonInnerContainer, { children: [wallet.installed && _jsx(InstalledIndicator, {}), _jsx(CpslText, { variant: "bodyXS", color: "secondary", weight: "medium", children: wallet.name })] }) }, wallet.id))), showMoreButton && (_jsxs(CpslButton, { variant: "tertiary", fullWidth: true, onClick: handleShowAll, children: [_jsx(CpslIcon, { slot: "start", icon: "wallet" }), "More Wallets"] })), showAll && _jsx(BlurContainer, {})] }));
};
const Container = styled.div `
  position: relative;
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;

  max-height: ${({ $maxHeight }) => ($maxHeight ? '348px' : 'none')};
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;
const WalletTileButton = styled(StyledCpslTileButton) `
  flex: 1;
`;
const WalletButtonOuterContainer = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
`;
const WalletButtonInnerContainer = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;

  cpsl-icon {
    --icon-color: var(--cpsl-color-contrast);
  }
  cpsl-text {
    &::part(text-element) {
      color: var(--cpsl-color-contrast);
    }
  }
`;
const Badge = styled.div `
  visibility: ${({ $show }) => ($show ? 'visible' : 'hidden')};
  padding: 2px 4px;
  border-radius: 4px;
  border: 1px solid;
  border-color: ${({ $variant }) => $variant === 'installed' ? 'var(--cpsl-color-utility-green)' : 'var(--cpsl-color-text-primary)'};
  cpsl-text {
    &::part(text-element) {
      color: ${({ $variant }) => $variant === 'installed' ? 'var(--cpsl-color-utility-green)' : 'var(--cpsl-color-text-primary)'};
    }
  }
`;
const InstalledIndicator = styled.span `
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background-color: var(--cpsl-color-utility-green);
`;
const TileButtonInnerContainer = styled.div `
  display: flex;
  gap: 4px;
  align-items: center;
`;
const SearchIcon = styled(CpslIcon) `
  --icon-color: var(--cpsl-color-contrast);
`;
const SearchInputWrapper = styled.div `
  width: 100%;
  background-color: var(--cpsl-color-background-0);

  position: sticky;
  top: 0;
  padding-bottom: 4px;
  margin-bottom: -4px;
`;
const SearchInput = styled(CpslInput) `
  width: 100%;
  --container-background-color: var(--cpsl-color-background-8);
  --input-background-color: var(--cpsl-color-background-8);
`;
const BlurContainer = styled.div `
  position: sticky;
  height: 56px;
  width: 100%;
  bottom: 0;

  background: linear-gradient(0deg, var(--cpsl-color-background-0) 0%, rgba(234, 239, 211, 0) 100%);
  pointer-events: none;
`;
